import scrollbar from "../styles/scrollbar";
import simplebar from "../styles/simplebar";
import echart from "../styles/echart";
import swiper from "../styles/swiper";

const CssBaseline = {
  defaultProps: {},
  styleOverrides: (theme) => ({
    html: {
      scrollBehavior: "smooth",
      WebkitOverflowScrolling: "touch",
      boxSizing: "border-box",
      scrollbarColor: "#21222D #171821",
    },
    "*, *::before, *::after": {
      margin: 0,
      padding: 0,
    },
    "a, a:link, a:visited": {
      textDecoration: "none !important",
    },
    "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
      color: `${theme.palette.primary.main} !important`,
      transition: "color 150ms ease-in !important",
    },
    "a.link:hover, .link:hover, a.link:focus, .link:focus": {
      color: `${theme.palette.info.main} !important`,
    },
    body: {
      fontVariantLigatures: "none",
      ...scrollbar(theme),
    },
    ...simplebar(theme),
    ...swiper(theme),
    ...echart(),
  }),
};

export default CssBaseline;
